<div
  class="relative frm-image {{ styleClass }}"
  [ngStyle]="style">
  @for (currentSrc of [src]; track currentSrc) {
    <img
      [src]="currentSrc"
      [alt]="alt"
      [attr.loading]="lazy ? 'lazy' : null"
      [attr.decoding]="decoding"
      [class]="imageClass"
      [style]="imageStyle"
      [style.width]="width"
      [style.height]="height" />
  }

  <div
    class="frm-image-hover absolute top-0 left-0 h-full w-full z-5"
    [class.cursor-pointer]="preview || isShowIndicator"
    (click)="preview ? openPreview() : onClickImage.emit()">
    <ng-container *ngIf="isShowIndicator">
      <ng-container *ngIf="indicatorTemplate; else defaultIndicatorTemplate">
        <ng-template [ngTemplateOutlet]="indicatorTemplate"></ng-template>
      </ng-container>
      <ng-template #defaultIndicatorTemplate>
        <div class="flex align-items-center h-full justify-content-center w-full bg-black-alpha-40">
          <i class="pi pi-eye text-white"></i>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>

<crm-galleria
  [visible]="visible"
  (visibleChange)="onGalleriaVisibleChange($event)"
  [images]="[{ src: galleriaImageSrc, alt: alt, id: galleriaImageSrc }]"
  [appendTo]="appendTo"></crm-galleria>
